import { useEffect, useState } from 'react';
import { languageTag } from '@/paraglide/runtime';

export const useGetLanguageHelper = () => {
  const local = languageTag();
  const [content, setContent] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        const lang = await import(
          `@/features/change-config/const/config-helpers/${local}.json`
        );
        setContent(lang);
      } catch (error) {
        /* empty */
      }
    };

    loadContent();
  }, [local]);

  return [content];
};
